import * as signalR from "@microsoft/signalr";

let connection = null;

// let userId = "9013"
export async function initSignalR(userId) {
  const urlConnectionSignalR = process.env.REACT_APP_URL_CONNECTION_SIGNALR;

  // 🚨 evitar doble conexión
  if (connection) return connection;

  connection = new signalR.HubConnectionBuilder()
    .withUrl(urlConnectionSignalR+"?apikey=SDDEW_rwerew_423545_323423")
    .withAutomaticReconnect()
    .build();

  try {
    await connection.start();

    await connection.invoke("JoinSession", userId);
  } catch (err) {
    console.error("❌ Error SignalR:", err);
  }

  return connection;
}

export async function stopSignalR() {
  if (!connection) return;

  try {
    if (connection.state === signalR.HubConnectionState.Connected) {
      await connection.invoke("LeaveSession");
    }
  } catch (err) {
    console.warn("LeaveSession falló:", err?.message);
  }

  try {
    await connection.stop();
  } catch (err) {
    console.warn("Stop falló:", err?.message);
  }

  connection = null;
}

export function getSignalRConnection() {
  return connection;
}
